import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "../lib/api";

export default function Processing() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState({ registrationStatus: "PENDING_PAYMENT", paymentStatus: "PENDING" });

  useEffect(() => {
    let alive = true;
    const tick = async () => {
      try {
        const { data } = await api.get(`/api/registrations/${id}/status`);
        if (!alive) return;
        setStatus(data);
        if (data.registrationStatus === "COMPLETED" || data.paymentStatus === "SUCCESS") {
          navigate(`/result/${id}?state=success`, { replace: true });
        } else if (data.registrationStatus === "FAILED" || data.paymentStatus === "FAILED") {
          navigate(`/result/${id}?state=failed`, { replace: true });
        }
      } catch {}
    };

    tick();
    const t = setInterval(tick, 3000);
    return () => { alive = false; clearInterval(t); };
  }, [id, navigate]);

  return (
    <div style={{ minHeight:"100vh", display:"grid", placeItems:"center", padding:24 }}>
      <div style={{ textAlign:"center" }}>
        <h2>Processing your payment…</h2>
        <p>Registration ID: {id}</p>
        <p>Status: {status.registrationStatus} / {status.paymentStatus}</p>
        <p>We will update automatically.</p>
      </div>
    </div>
  );
}
